export const FETCH_PACKAGE_REQUEST = "FETCH_PACKAGE_REQUEST";
export const UPDATE_PACKAGE_REQUEST = "UPDATE_PACKAGE_REQUEST";
